import { FC } from 'react';
import classNames from 'classnames';
import getClassNames from 'src/common/utils/getClassNames';
import styles from './Divider.module.scss';

export type DividerProps = {
  size?: 'none' | 'xs' | 's' | 'm' | 'l' | 'xl';
  spacePosition?: 'above' | 'below' | 'both';
  color?: 'neutral-300' | 'neutral-200' | 'neutral-100';
};

const Divider: FC<DividerProps> = ({
  size = 'none',
  spacePosition = 'both',
  color = 'neutral-300',
}) => (
  <hr className={getClassNames(styles, 'root', classNames(size, spacePosition, color))} />
);

export default Divider;
